module.exports = __webpack_public_path__ + "img/multi_chat_default.a5c24206.png";